import APIS from 'src/constants/ApiConfig';
import HttpService from 'src/services/HttpService';
import { ITaskInfo } from 'src/entity/TaskEntity';

/**
 * 任务service
 * @class TaskService
 */
class TaskService {
  /**
   * 根据任务id查询任务状态
   *
   * @param {string} taskId
   * @returns {Promise<ITaskInfo>}
   * @memberof TaskService
   */
  async getTaskById(taskId: string): Promise<ITaskInfo> {
    return HttpService.get(`${APIS.domainUrl(APIS.taskStatus)}${taskId}/`);
  }
}

export default new TaskService();



// WEBPACK FOOTER //
// ./src/services/TaskService.ts